import { Component, Inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { filter, Observable, Subject, takeUntil } from "rxjs";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { HttpService } from "../../service/HTTPService/HttpService";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

import { Router, ActivatedRoute } from "@angular/router";
import {
  InteractionStatus,
  EventMessage,
  EventType,
  AuthenticationResult,
} from "@azure/msal-browser";
import * as CryptoJS from "crypto-js";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import { UserSettingDataService } from "../../service/userSettingDataService/userSettingData.service";

@Component({
  selector: "app-login",
  styleUrls: ["login.css"],
  templateUrl: "login.component.html",
})
export class LoginComponent {
  private _destroying$ = new Subject<void>();
  type: string;
  message: string;
  alerts: any[] = [];
  menus: any[] = [];
  submenu: any[] = [];
  internalLinks: any[] = [];
  users: any[] = [];
  expiryDate;
  cookieValue = "UNKNOWN";
  ExpDateFormat: NgbDate;
  validateLogin;
  landingPage;
  userType;
  PresentDate;
  PasswordInput = false;
  isIframe = false;
  correlationId = "1234";
  isAzureLogin;
  private azureEnabled: boolean = false;
  private azureClientID: string = "4da6c207-7499-4849-85c9-da032a2022fa";
  private azureTenantID: string = "06815d30-c3a7-41f1-ae74-0fda03852c96";
  private Azuremessage: string;
  StringEncrpt = "";
  version = "";
  tokenExpiration: string = "";
  allAccounts;
  profile;
  tokenResponse: AuthenticationResult | null = null;
  loginDisplay = false;
  userSettings;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient,
    private http1: HttpService,
    private spinner: NgxSpinnerService,
    private readonly route: ActivatedRoute,
    private urlAuthentication: BindingURLService,
    private router: Router,
    private apiUrl: ApiService,
    private userSettingService: UserSettingDataService,
  ) {
    this.isAzureLogin = (window as any).__env.isAzureLogin;
    localStorage.clear();
    sessionStorage.clear();

    this.version = (window as any).__env.version;
    let Todaydate = new Date();
    this.checkedValue = 0;
    this.PresentDate = Todaydate.getFullYear();
  }
  async initialize(): Promise<void> {
    await this.authService.instance.initialize();
  }
  async ngOnInit(): Promise<void> {
    await this.initialize();

    // Monitor interaction status
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None,
        ),
        takeUntil(this._destroying$),
      )
      .subscribe(() => {
        // No interaction is in progress
        this.allAccounts = this.authService.instance.getAllAccounts();
        if (this.allAccounts.length > 0) {
          this.loginDisplay = true;
        } else {
          this.loginDisplay = false;
        }
      });

    // Listen for login or token acquisition success
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS,
        ),
        takeUntil(this._destroying$),
      )
      .subscribe((msg: EventMessage) => {
        const payload = msg.payload as AuthenticationResult;
        this.tokenResponse = payload;
      });
  }

  sendTokenToBackend(tokenResult: any) {
    this.spinner.show();
    const payloadJson = {
      response1: {
        token_type: tokenResult?.token_type,
        scope: tokenResult?.scope,
        expires_in: tokenResult?.expires_in,
        ext_expires_in: tokenResult?.ext_expires_in,
        access_token: tokenResult?.access_token,
        refresh_token: tokenResult?.refresh_token || "",
        refresh_token_expires_in: tokenResult?.refresh_token_expires_in || "",
        id_token: tokenResult?.id_token,
        client_info: tokenResult?.client_info || "",
      },
    };

    this.getAzureLoginApi(payloadJson).subscribe(
      (res) => {
        const resp = res.body;

        if (resp.code == 200) {
          const respData = resp.data;
          const token = respData.token;
          this.landingPage = respData.landingPageUrl;
          this.userType = respData.userType;
          const accTimeZone = respData?.accountTimeZone
            ? respData?.accountTimeZone
            : 0;
          const accCode = respData.accountCode ? respData.accountCode : "";

          const userLoginName = respData?.userName ? respData.userName : "";
          this.getInterLinksAssigned();
          sessionStorage.setItem("invUIToken", token);
          localStorage.setItem("invMonitoring", "invLoggedIn");
          sessionStorage.setItem("user", userLoginName);
          sessionStorage.setItem("userType", this.userType);
          sessionStorage.setItem("accCode", accCode);
          sessionStorage.setItem("custTimeZone", accTimeZone);

          this.spinner.hide();
        } else {
          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: resp.body.message,
          });

          this.spinner.hide();
        }
      },
      (error) => {
        console.error(error);
        this.spinner.hide();
        if (error) {
          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: error.error.message,
          });
          this.spinner.hide();
        }
      },
    );
  }


  ValidateLogin(username, Password) {
    let Azuretoken = {};
    this.spinner.show();
    if (this.checkedValue == 1) {
      Password = "";

      if (username && (Password == null || Password == "")) {
        // First check if there's an authentication in progress
        if (this.isInteractionInProgress()) {
          console.warn("Authentication already in progress, please wait...");
          this.alerts = [];
          this.alerts.push({
            type: "warning",
            message: "Authentication already in progress, please wait...",
          });
          this.spinner.hide();
          return;
        }

        $("#azureID").prop("checked", false);
        $("#UsernameId").val("");
        sessionStorage.clear();

        // Use loginPopup instead of loginRedirect for consistency with AzureLogin method
        this.getDirectAzureToken(username).subscribe({
          next: (tokenResponse) => {
            if (tokenResponse && tokenResponse.access_token) {
              this.sendTokenToBackend(tokenResponse);
            }
          },
          error: (error) => {
            console.error("Azure login error:", error);
            this.alerts = [];
            this.alerts.push({
              type: "danger",
              message: "Azure login failed. Please try again.",
            });
            this.spinner.hide();
          },
        });
      } else {
        this.alerts = [];
        this.alerts.push({
          type: "danger",
          message: "Please enter valid User Name / Email id",
        });
        this.spinner.hide();
      }
    } else if (this.checkedValue == 0) {
      if (username == "" || Password == "") {
        this.alerts = [];
        this.spinner.hide();
        this.alerts.push({
          type: "danger",
          message: "Log In failed, Please enter valid User Name & Password!!!",
        });
      } else {
        const loginJson = {
          username: username,
          password: Password,
        };
        this.getLoginApi(loginJson).subscribe(
          (res) => {
            const resp = res;
            if (resp.code == 200) {
              const respData = resp.data;
              const token = respData.token;
              this.landingPage = respData.landingPageUrl;
              this.userType = respData.userType;
              const accTimeZone = respData.accountTimeZone
                ? respData.accountTimeZone
                : 0;
              const accCode = respData.accountCode ? respData.accountCode : "";
              const userLoginName = respData.UserName
                ? respData.UserName
                : username;

              sessionStorage.setItem("invUIToken", token);
              localStorage.setItem("invMonitoring", "invLoggedIn");
              sessionStorage.setItem("user", userLoginName);
              sessionStorage.setItem("userType", this.userType);
              sessionStorage.setItem("accCode", accCode);
              sessionStorage.setItem("custTimeZone", accTimeZone);
              // localStorage.setItem("accCode", accCode);
              // localStorage.setItem("user", userLoginName);
              // localStorage.setItem("custTimeZone", accTimeZone);
              // const encrypted = this.DoEncrypt(JSON.stringify(respData));
              // sessionStorage.setItem("userData", encrypted);

              this.userSettingService.fetchUserSettings();
              this.userSettingService
                .getUserSettings()
                .subscribe((settings) => {
                  if (settings) {
                    this.userSettings = settings;
                  }
                });

              this.getInterLinksAssigned();
            } else {
              this.alerts = [];
              this.alerts.push({
                type: "danger",
                message: resp.message,
              });

              this.spinner.hide();
            }
          },
          (error) => {
            console.error(error);

            if (error) {
              this.alerts = [];
              this.alerts.push({
                type: "danger",
                message: error.error.message,
              });
              this.spinner.hide();
            }
          },
        );
      }
    }
  }

  getCustomerID() {
    this.http1
      .get(this.urlAuthentication.itocUrl + this.apiUrl.getCustomerIDUrl)
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res);
          const resp = JSON.parse(getImgResp);
          let customerId = resp;
          sessionStorage.setItem("customerID", customerId);
        },
        (error) => {
          console.error(error);
        },
      );
  }
  // getLoginApi(loginJson): Observable<any> {
  //   let uname = loginJson.username;
  //   let pswd = loginJson.password;
  //   const url = this.urlAuthentication.loginUrl;
  //   var authorizationBasic = uname + "," + pswd;
  //   const encryptUserName = this.DoEncrypt(authorizationBasic);
  //   const httpHeaders = {
  //     headers: new HttpHeaders()
  //       .set("Accept", "application/json")
  //       .set(
  //         "Content-Type",
  //         "application/x-www-form-urlencoded; charset=utf-8"
  //       ),
  //   };
  //   let queryParms = new HttpParams().set("request", encryptUserName);
  //   return this.http.post(
  //     url + this.apiUrl.jwtloginUrl,
  //     { headers: httpHeaders, observe: "response" },
  //     {
  //       params: queryParms,
  //     }
  //   );
  // }

  getLoginApi(loginJson): Observable<any> {
    const uname = loginJson.username;
    const pswd = loginJson.password;

    const httpHeaders = {
      headers: new HttpHeaders()
        .set("Accept", "application/json")
        .set("Content-Type", "application/json"),
    };

    return this.http.post(
      this.urlAuthentication.loginUrl + this.apiUrl.jwtloginUrl,
      { UserName: uname, Password: pswd },
      httpHeaders,
    );
  }

  getAzureLoginApi(loginJson: any): Observable<any> {
    const url = this.urlAuthentication.loginUrl + this.apiUrl.azureLoginUrl;

    // Set the correct content type for JSON payload
    const httpHeaders = new HttpHeaders()
      .set("Accept", "application/json")
      .set("Content-Type", "application/json");

    const options = {
      headers: httpHeaders,
      observe: "response" as const,
    };

    // Send the data as JSON
    return this.http.post(url, loginJson, options);
  }

  close(alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
  addSubMenus(name) {
    this.submenu.push(name);
    return this.submenu;
  }
  forgetPassword() {
    window.open("#/login", "_self");
    this.otherForgetPass();
  }
  otherForgetPass() {
    window.open("#/forgetPassword", "_self", "");
  }
  getInterLinksAssigned() {
    this.spinner.hide();
    let landingPage = this.landingPage;
    if (landingPage) {
      window.open("#/" + this.landingPage, "_self", "");
    } else {
      window.open("#/" + "104", "_self", "");
    }
  }
  isChecked: any;
  checkedValue = 0;
  /**
   * Get an Azure token using MSAL to authenticate the user
   * Returns the token in exactly the format needed by the backend
   */
  // Helper method to check if an MSAL interaction is in progress
  private isInteractionInProgress(): boolean {
    return (
      this.authService.instance.getActiveAccount() !== null &&
      this.authService.instance.getActiveAccount() !== undefined
    );
  }

  getDirectAzureToken(loginHint?: string): Observable<any> {
    // Use Subject to create an observable that we control
    const tokenSubject = new Subject<any>();

    // First check if there's an interaction in progress
    if (this.isInteractionInProgress()) {
      tokenSubject.error(
        "Authentication already in progress. Please wait for it to complete.",
      );
      return tokenSubject.asObservable();
    }

    // Configure authentication options
    const authOptions: any = {
      scopes: ["user.read", "openid", "profile", "email"],
      prompt: "select_account",
    };

    // Add login hint if provided
    if (loginHint) {
      authOptions.loginHint = loginHint;
    }

    // Authenticate with popup (more consistent than redirect for this scenario)
    this.authService.loginPopup(authOptions).subscribe({
      next: (msalAuthResult) => {
        if (msalAuthResult && msalAuthResult.accessToken) {
          // We already have the token from the login response
          // Format it exactly as expected by the backend
          const account = this.authService.instance.getAllAccounts()[0];

          // Format response to match exactly what the backend expects
          const directTokenResponse = {
            token_type: msalAuthResult.tokenType,
            scope: msalAuthResult.scopes.join(" "),
            expires_in: msalAuthResult.expiresOn
              ? Math.floor(
                  (msalAuthResult.expiresOn.valueOf() - Date.now()) / 1000,
                )
              : 3600,
            ext_expires_in: msalAuthResult.extExpiresOn
              ? Math.floor(
                  (msalAuthResult.extExpiresOn.valueOf() - Date.now()) / 1000,
                )
              : 3600,
            access_token: msalAuthResult.accessToken,
            refresh_token: "", // MSAL doesn't expose refresh token directly
            refresh_token_expires_in: 86399, // Default to 24 hours - 1 second
            id_token: msalAuthResult.idToken,
            client_info: account ? account.homeAccountId : "",
          };

          tokenSubject.next(directTokenResponse);
          tokenSubject.complete();
        } else {
          tokenSubject.error(
            "Authentication successful but no access token received",
          );
        }
      },
      error: (error) => {
        tokenSubject.error(error);
      },
    });

    return tokenSubject.asObservable();
  }

  AzureLogin = (evt) => {
    this.isChecked = evt.target.checked;
    if (this.isChecked == true) {
      // Hide the password field as we'll use Azure authentication
      this.PasswordInput = true;
      this.checkedValue = 1;

      // First check if there's an interaction in progress
      if (this.isInteractionInProgress()) {
        console.warn("Authentication already in progress, please wait...");
        this.alerts = [];
        this.alerts.push({
          type: "warning",
          message: "Authentication already in progress, please wait...",
        });
        return;
      }

      // Use our optimized getDirectAzureToken method
      this.getDirectAzureToken().subscribe({
        next: (tokenResponse) => {
          if (tokenResponse && tokenResponse.access_token) {
            // Token is already formatted correctly by getDirectAzureToken()
            // Send it directly to the backend
            this.sendTokenToBackend(tokenResponse);
          }
        },
        error: (error) => {
          console.error("Azure login error:", error);
          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: "Azure login failed. Please try again.",
          });
          this.PasswordInput = false;
          this.checkedValue = 0;
          this.isChecked = false;
        },
      });
    } else {
      // User unchecked the Azure login, show the password field
      this.PasswordInput = false;
      this.checkedValue = 0;
    }
  };

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
